import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Main from "./component/Home/Main";
import Nav from "./component/Nav";
import Footers from "./component/Footer/Footer";
import Details from "./component/Home/details/Details";
import FreshStart from "./component/Home/details/components/FreshStart-details";
import SpeakYourMind from "./component/Home/details/components/SpeakYourMind-details";
import EnglishAtWork from "./component/Home/details/components/EnglishAtWork-details";
import DictationCourse from "./component/Home/details/components/DictationCourse-details";
import IntonationCourse from "./component/Home/details/components/IntonationCourse-details";
import VocaBoost from "./component/Home/details/components/VocaBoost-details";
import IELTS from "./component/Home/details/components/IELTS&TOEIC-details";
import PhonoKEY from "./component/Home/details/components/PhonoKEY-details";
import About from "./component/about/About";
import Contact from "./component/Contact/Contact";
import Blog from "./component/blog/Pronounciation Blog/BlogDefault";
import BlogPost1Page from "./component/blog/Pronounciation Blog/BlogPost1Page";
import BlogPost2Page from "./component/blog/Pronounciation Blog/BlogPost2Page";
import BlogPost3Page from "./component/blog/Pronounciation Blog/BlogPost3Page";
import BlogPost4Page from "./component/blog/Pronounciation Blog/BlogPost4Page";
import BlogGrammar from "./component/blog/Grammar Blog/BlogGrammar";
import BlogMotivational from "./component/blog/Motivational Blogs/BlogMotivational";
import GrammarCard1 from "./component/blog/Grammar Blog/GrammarCard1";
import GrammarCard2 from "./component/blog/Grammar Blog/GrammarCard2";
import GrammarCard3 from "./component/blog/Grammar Blog/GrammarCard3";
import GrammarCard4 from "./component/blog/Grammar Blog/GrammarCard4";
import PhonoKEY2 from "./component/Home/details/components/PhonoKey-details2";
import BlogMotivationalCard from "./component/blog/Motivational Blogs/BlogMotivationalCard";
import EnglishForCareer from "./component/Home/EnglishForCareer";
import Terms from "./component/terms/Terms";
import NewsletterForm from "./component/Home/Newsletter";

function ScrollToTopOnPageChange() {
  // This component remains the same as in your previous code
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTopOnPageChange />
      <Nav />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/courses/:category" element={<Details />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path='/Newsletter' element={<NewsletterForm/>}/>
        <Route path="/englishforcareer" element={<EnglishForCareer />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/pronunciation" element={<Blog />} />
        <Route path="/blog/Grammar/Possessive Pronouns" element={<GrammarCard1 />} />
        <Route path="/blog/Grammar/Is_the_verb_be_interchangeable?" element={<GrammarCard2 />} />
        <Route path="/blog/Grammar/When_it’s_time_to_see_your_doctor" element={<GrammarCard3 />} />
        <Route path="/blog/Grammar/Which_verbs_aren’t_interchangeable_in_English?" element={<GrammarCard4 />} />
        <Route path="/blog/Grammar/" element={<BlogGrammar />} />
        <Route path="/blog/motivational/Your_Learning_Autonomy:_English_Where_You_Need_It" element={<BlogMotivational />} />
        <Route path="/blog/motivational" element={<BlogMotivationalCard />} />
        <Route path="/blog/pronunciation/I_need_to_use_English_at_my_new_job" element={<BlogPost1Page />} />
        <Route path="/blog/pronunciation/Do_you_often_misunderstand_native_speakers?" element={<BlogPost2Page />} />
        <Route path="/blog/pronunciation/Common_Challenges_for_French_Speakers_in_English_Pronunciation" element={<BlogPost3Page />} />
        <Route path="/blog/pronunciation/Spanish_People_Struggle_with_English_Pronunciation" element={<BlogPost4Page />} />
        <Route path="/courses/FreshStart" element={<FreshStart />} />
        <Route
          path="/courses/SpeakYourMind"
          element={<SpeakYourMind />}
        />
        <Route
          path="/courses/EnglishAtWork"
          element={<EnglishAtWork />}
        />
        <Route path="/courses/PhonoKEY" element={<PhonoKEY2 />} />
        <Route
          path="/courses/DictationCourse"
          element={<DictationCourse />}
        />
        <Route
          path="/courses/IntonationCourse"
          element={<IntonationCourse />}
        />
        <Route path="/courses/VocaBoost" element={<VocaBoost />} />
      {/* <Route path="/courses/Ielts&Toeic" element={<IELTS />} /> */}
        <Route path="/courses/Ielts&Toeic" element={<IELTS />} />
        <Route path="/temrs&conditions" element={<Terms />} />
      </Routes>
      <Footers />
    </BrowserRouter>
  );
}

export default App;
